exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-6c2cd15c]{width:100%;height:100vh;position:absolute;z-index:999;background:rgba(0,0,0,.5)}.loader-image[data-v-6c2cd15c]{margin:20% auto}.main-loader-div[data-v-6c2cd15c]{width:20%;margin:auto}.loader-div[data-v-6c2cd15c]{width:20%;background-color:#fff;margin:23% auto;padding:40px;border-radius:13px}@media only screen and (min-width:320px){.loader-div[data-v-6c2cd15c]{width:65%;margin:60% auto}}@media only screen and (min-width:768px){.loader-div[data-v-6c2cd15c]{width:40%;margin:40% auto}}@media only screen and (min-width:1024px){.loader-div[data-v-6c2cd15c]{width:30%;margin:30% auto}}@media only screen and (min-width:1200px){.loader-div[data-v-6c2cd15c]{width:20%;margin:21% auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c2cd15c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 23
// module chunks = 188